import React from 'react'
import "./OurTeam.css"
import TextCardBox from '../DropContentCard/TextCardBox'

const teamCardData = [
    {
        heading:"Our Vision",
        para:"Our vision is to be the driving force that makes therapeutic rehabilitation safe, easy and convenient for everyone. We are certain that by utilizing innovative Laser Technology that we will transform the delivery of pain management and accelerated healing. Making healthcare accessible to all, will allow our clients to receive treatment in the comfort of their own homes wherever they call home.",
        iconRef:'/images/icons/about-card-icon-1.png'
    },
    {
        heading:"Mission Statement",
        para:"To conveniently and safely administer pain relief and accelerated healing in our clients homes using the world renowned Bioflex Laser System.",
        iconRef:'/images/icons/about-card-icon-2.png'
    },
    {
        heading:"Our Story",
        para:"Founder Tina Doney recognized that time is valuable in our ever changing fast paced society. We understand that traveling to a clinic is time consuming for busy people and busy families and there are others who are unable to travel to a clinic.  By changing the landscape of care delivery, we are committed to making pain relief and healing safe, convenient and effective.",
        iconRef:'/images/icons/about-card-icon-3.png'
    },
]


function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    } else {
      return text.substring(0, maxLength - 3) + '...';
    }
  }

function OurTeam() {
  return (
    <div className='OurTeam-container standard-padding-space'>
        <div className='container py-4'>
            <div className='text-content text-center '>
                <h3 className='body-heading mb-5'>WHO WE ARE</h3>
               
            </div>

            <div className='row  pt-4 gy-lg-0 gy-4'>
                    {
                        teamCardData.map((ele)=>{
                            return(
                                <div className='col-lg-4 px-lg-4 px-2'>
                                    {/* <div className='team-card '>
                                        <h6 style={{fontWeight:"600",color:"#4293b6"}} className='text-lg-start text-center mb-3'>{ele.heading}</h6>
                                        <p className="text-lg-start text-center" style={{color:"#6cb4c6"}}>{ele.para}</p>
                                    </div> */}
                                    <TextCardBox
                                        title={ele.heading}
                                        breifPara={truncateText(ele.para,85)}
                                        actualPara={ele.para}
                                        iconRef={ele.iconRef}
                                    />
                                </div>
                            )
                        })
                    }
            </div>
        </div>
    </div>
  )
}

export default OurTeam